import useIsExternalTheme from '@gef-ui/material/hooks/useIsExternalTheme';
import PropTypes from 'prop-types';
import React from 'react';
import { closeErrorMultiple, closeErrorSingle, removeErrorSingle } from '../../actions';
import { useErrorContext, useErrorDispatch } from '../../context';
import { useDefaultComponentValue } from '../../utils';
import ModalError from '../ModalError';
import ModalMultipleErrors from '../ModalMultipleErrors';
import SimpleModalError from '../SimpleModalError';
const COMPONENT_NAME = 'MuiModalErrorProvider';
const ModalErrorProvider = (inProps)=>{
    const props = useDefaultComponentValue({
        name: COMPONENT_NAME,
        inProps
    });
    const { actionButtonSingle, withCloseButtonSingle, ...other } = props;
    const dispatch = useErrorDispatch();
    const { error, isModalErrorVisible, isModalMultipleErrorsVisible } = useErrorContext();
    const closeModalError = ()=>dispatch(closeErrorSingle());
    const removeModalError = ()=>dispatch(removeErrorSingle());
    const closeModalMultipleErrors = ()=>dispatch(closeErrorMultiple());
    const isExternalTheme = useIsExternalTheme();
    const ErrorComponent = isExternalTheme ? SimpleModalError : ModalError;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ErrorComponent, {
        error: error,
        open: isModalErrorVisible,
        onCloseModal: withCloseButtonSingle ? closeModalError : undefined,
        TransitionProps: {
            onExited: removeModalError
        },
        actionButton: actionButtonSingle,
        ...other
    }), /*#__PURE__*/ React.createElement(ModalMultipleErrors, {
        open: isModalMultipleErrorsVisible,
        onCloseModal: closeModalMultipleErrors,
        ...other
    }));
};
ModalErrorProvider.propTypes = {
    actionButtonSingle: PropTypes.node,
    withCloseButtonSingle: PropTypes.bool
};
export default ModalErrorProvider;
